import React, { useEffect, useRef } from 'react';
import Img from '../Img';
import { getLabel } from '../../InitData';

export default function SearchBar(props) {
    const inputRef = new useRef(null);

    useEffect(() => {
        function listener() {
            inputRef.current.value = '';
        }

        window.addEventListener('xs_openEvent', listener);
        return () => {
            window.removeEventListener('xs_openEvent', listener);
        };
    }, []);

    function handleChange(event) {
        window.dispatchEvent(new CustomEvent('xs_search', {detail: event.target.value}));
    }

    return (
        <>
            <div className="c_4">
                <Img className="c_4_1" src="icon_search.svg" height="32px" width="32px" />
                <input className="c_4_2" type="text" placeholder={getLabel('general.search')} onClick={(e) => e.stopPropagation()} onChange={handleChange} ref={inputRef} />
            </div>
            <div id="xs-search-results"></div>
        </>
    );
}
